import * as React from 'react';
import { RatingsRedesigned } from '../../components/RatingsRedesigned';
import { useSelector } from 'react-redux';
import { getReviewsStats } from '../../selectors/developerV2';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { trackHeaderReviewsClick } from '../Reviews/tracking';

export const Ratings = () => {
  const { reviewCountText, totalRate, reviewCount } = useSelector(getReviewsStats);

  /* istanbul ignore next */
  const onClick = React.useCallback((event: React.MouseEvent) => {
    scrollToAnchor({ anchor: '#reviews', hasRelocation: false, offset: 0 })(event);

    setTimeout(trackHeaderReviewsClick, 0);
  }, []);

  return (
    <RatingsRedesigned
      onClick={onClick}
      reviewCountText={reviewCountText}
      totalRate={totalRate}
      reviewCount={reviewCount}
    />
  );
};
